export const PREFERRED_LANGUAGE_OPTIONS = [
  { value: 'fr', label: 'Français' },
  { value: 'en', label: 'Anglais' },
  { value: 'es', label: 'Espagnol' },
];

export const getPreferredLanguageName = languageCode =>
  PREFERRED_LANGUAGE_OPTIONS.find(option => option.value === languageCode)
    ?.label || '';
